module.exports = __webpack_public_path__ + "static/media/OlaFrontWeb.ef885831.jpg";